import type { DeleteDialogSourceOptions } from '@cli-types/next-adapter/generators.js'
import { quoteLiteral } from '@cli-utils/text.js'
import { escapeJsx } from '@cli-utils/text.js'
import { renderBuildDeleteDialogSourceClientModuleTemplate } from '@next-adapter/templates/renderers/generators/row-actions-emitters/build-delete-dialog-source.js'

export function buildDeleteDialogSource({
  componentName,
  deleteActionName,
  actionImportPath,
  noun,
  queryKey
}: DeleteDialogSourceOptions): string {
  return renderBuildDeleteDialogSourceClientModuleTemplate({
    deleteActionName: deleteActionName,
    actionImportPath: actionImportPath,
    componentName: componentName,
    quoteLiteral: quoteLiteral(`${noun} deleted`),
    queryKey: queryKey,
    quoteLiteralQuotedValue: quoteLiteral(`Failed to delete this ${noun}`),
    quoteLiteralText: quoteLiteral(`Failed to delete this ${noun}. Try again.`),
    escapeJsx: escapeJsx(noun),
    quoteLiteralContent: quoteLiteral(`Delete ${noun}`)
  })
}
